import { ds } from "js/core/models/dataService";
import { $, _ } from "js/vendor";
import { getStaticUrl } from "js/config";
import { app } from "js/namespaces";
import { slideTemplates } from "js/core/slide_templates/slide_template";
import { SideBarCanvasModifier } from "common/constants";
import { controls, SideBar } from "js/editor/ui";
import { ShowDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { renderReactDialog } from "js/react/renderReactRoot";
import { SwitchTemplateDialog } from "js/editor/TemplateSwitcher/SwitchTemplateDialog";

const VariationsPanel = SideBar.extend({
    className: "styles_panel",

    closeOnCanvasClick: true,
    showHeader: false,
    lockSlide: true,

    getPanelHeight: function() {
        return 142;
    },

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    getTitle: function() {
        return "Variations";
    },

    setup: function(options) {
        this.styles = options.styles || [];
    },

    renderContents: function() {
        this.$contents.spinner(false);

        for (let style of this.styles) {
            let $style = $.div("style_thumbnail");
            let $thumbnail = $style.addEl($.div("thumbnail"));

            if (style.icon) {
                $thumbnail.append($.img(getStaticUrl(`/images/template-icons/${style.icon}.svg`)));
            } else {
                let slideTemplate = slideTemplates[style.template];
                if (slideTemplate) {
                    $thumbnail.append($.img(getStaticUrl(`/images/template-icons/${slideTemplate.icon}.svg`)));
                }
            }

            $style.append($.label(style.label));
            this.$contents.append($style);

            $style.on("click", () => {
                const currentTemplate = ds.selection.slide.get("template_id");

                const element = this.canvas.getPrimaryElement();

                if (style.model || style.getModel) {
                    let model = style.getModel ? style.getModel(currentTemplate) : style.model;
                    if (model.primary) {
                        // trim any arrays in the model that are being modified so we remove orphaned children
                        let clearArrayProps = (targetModel, sourceModel, path) => {
                            let sourceNode = path ? _.get(sourceModel, path) : sourceModel;
                            if (sourceNode && typeof sourceNode === "object") {
                                for (let key of Object.keys(sourceNode)) {
                                    if (sourceNode[key] instanceof Array) {
                                        let targetNode = path ? _.get(targetModel, path) : targetModel;
                                        targetNode[key] = _.take(targetNode[key], sourceNode[key].length);
                                    } else {
                                        clearArrayProps(targetModel, sourceModel, path ? path + "." + key : key);
                                    }
                                }
                            }
                        };
                        clearArrayProps(element.model, model.primary, null);

                        _.merge(element.model, model.primary);
                    }
                }

                let transition = true;
                if (style.template && style.template !== currentTemplate) {
                    transition = false;
                    this.canvas.model.template_id = style.template;
                }
                if (style.callbackMethod) {
                    this.canvas.getPrimaryElement()[style.callbackMethod](style.callbackArguments, style);
                }

                this.canvas.updateCanvasModel(transition).then(() => {
                    app.mainView.editorView.updateCurrentCanvasUI();
                }).catch(err => {
                    ShowWarningDialog({
                        title: "Sorry, we were unable to make this change",
                        message: err.message,
                    });
                });
            });
        }
    }
});

export default VariationsPanel;
